import { format } from 'date-fns';

export const DateUTCToLocalDateString = (date: Date) => format(new Date(`${date?.toString()}Z`), 'dd MMMM, yyyy');
